import { ComponentType } from 'react';

export interface WorkOrderContext {
  id: string;
  order_number: string;
  product_name?: string;
  plybook_id?: string | null;
  mold_id?: string | null;
  assigned_operator?: string | null;
}

export interface ErrorActionProps {
  workOrder: WorkOrderContext;
  onSuccess: () => void;
  onCancel: () => void;
}

export interface ErrorAction {
  id: string;
  patterns: (string | RegExp)[];
  title: string;
  description: string;
  actionLabel: string;
  component: ComponentType<ErrorActionProps>;
}

const errorActionsRegistry: ErrorAction[] = [];

export function registerErrorAction(action: ErrorAction) {
  const existing = errorActionsRegistry.findIndex(a => a.id === action.id);
  if (existing >= 0) {
    errorActionsRegistry[existing] = action;
  } else {
    errorActionsRegistry.push(action);
  }
}

export function findMatchingAction(errorMessage: string): ErrorAction | null {
  const lowerMessage = errorMessage.toLowerCase();

  for (const action of errorActionsRegistry) {
    for (const pattern of action.patterns) {
      if (typeof pattern === 'string') {
        if (lowerMessage.includes(pattern.toLowerCase())) {
          return action;
        }
      } else if (pattern.test(errorMessage)) {
        return action;
      }
    }
  }

  return null;
}

export function getRegisteredActions(): ErrorAction[] {
  return [...errorActionsRegistry];
}
